import React from 'react'
import Table, { TableApiParamsType } from '../../components/Table'
import { axiosAPI } from '../../../engine/config/axios'

interface Params {
  category: string,
  userId: number
}

export default function UserFeedback({ category, userId }: Params) {
  const gridParams = {
    grids: [{ name: 'user_feedbacks' }],
  }

  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
    filters: loadOptions?.filter,
    sort: loadOptions?.sort,
    category,
    userId,
    ...pageParams
  });

  return <Table
    apiParams={apiParams}
    gridParams={gridParams}
    api={axiosAPI.userFeedbacks.table}
    gridName='user_feedbacks'
    sortingMode='multiple'
  />
}
